import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import LogoPNG from './logo.png';

/*
 * Customization with image
 *
 * If you have a jpg/png, do like this:
 *
 * <figure className="icon">
 *  <img src={logo} alt="" />
 * </figure>
 *
 * Note the icon class.
 */

const messages = defineMessages({
  stemma: {
    id: 'Stemma',
    defaultMessage: 'Stemma museo',
  },
});

const Logo = () => {
  const intl = useIntl();
  return (
    <>
      <img src={LogoPNG} alt={intl.formatMessage(messages.stemma)} />
    </>
  );
};

export default Logo;
